export const state = () => ({
  additionalDriver: defaultDriver,
  customer: defaultCustomer,
  jointCustomer: defaultCustomer,
  options: {},
  token: null,
  user: null
});

export const mutations = {
  clearAdditionalDriver (state) {
    state.additionalDriver = defaultDriver;
  },
  clearCustomer (state) {
    state.customer = defaultCustomer;
  },
  clearCustomerSupplyAddress (state) {
    state.customer.supply_address = null;
  },
  clearJointCustomer (state) {
    state.jointCustomer = defaultCustomer;
  },

  clearCredentials (state) {
    const { current_password: _cp, password: _p, password_confirmation: _pc, ...user } = state.user;
    state.user = user;
  },

  clearTfaData (state) {
    const { tfa_current_password: _tfaP, tfa_code: _tfaC,
            otp_secret: _otpS, qr_code_image: _qrImg, ...user } = state.user;
    state.user = user;
  },

  set (state, user) {
    if (state.user && user) {
      state.user = { ...state.user, ...user };
    } else {
      state.user = user;
    }
  },

  setAdditionalDriver (state, driver) {
    state.additionalDriver = { ...state.additionalDriver, ...(driver || {}) };
  },

  setCustomer (state, customer) {
    state.customer = { ...state.customer, ...(customer || {}) };
  },

  setJointCustomer (state, customer) {
    state.jointCustomer = { ...state.jointCustomer, ...(customer || {}) };
  },

  setOptions (state, options) {
    state.options = options;
  }
};

export const getters = {
  get (state) {
    return state.user;
  },

  getAdditionalDriver (state) {
    return state.additionalDriver;
  },

  getJointCustomer (state) {
    return state.jointCustomer;
  },

  getCustomer (state) {
    return state.customer;
  },

  getOptions (state) {
    return state.options;
  },

  getCustomerNewsletterState (state) {
    return state.customer.bonkers_mktg_optin;
  },

  getUserNewsletterState (state) {
    return state.user ? state.user.optin_newsletter : undefined;
  },

  getUserId (state) {
    return state.user ? state.user.id : undefined;
  },

  getUserEmail (state) {
    return state.user ? state.user.email : undefined;
  },

  getUserFName (state) {
    return state.user ? state.user.fname : undefined;
  },

  getUserSName (state) {
    return state.user ? state.user.sname : undefined;
  },

  getCustomerId (state) {
    return state.user ? state.customer.id : undefined;
  },
  canShowUserAddressCard (state) {
    const supplyAddress = state.user && state.user.supply_address;

    return !!(
      supplyAddress &&
      supplyAddress.addr_line1 &&
      supplyAddress.addr_line1.length > 0 &&
      supplyAddress.county &&
      supplyAddress.county.length > 0 &&
      supplyAddress.eircode &&
      supplyAddress.eircode.length > 0
    );
  },
  canShowUserProfileCard (state) {
    return !!(state.user && state.user.dob && state.user.mobile && getters.canShowUserAddressCard);
  }
};

const defaultDriver = {
  claims_total: 'no_claims',
  current_insurer_id: 'none',
  employment_business_id: '',
  employment_status_id: '',
  licence_type: '',
  licence_years_held: '',
  main: '',
  marital_status_id: '',
  named_driver_claims_free_years: '',
  named_driver_policy_insurer_id: 'none',
  no_claims_years: '',
  occupation_id: '',
  penalty_points: 'no_points',
  relationship_id: '',
  title: ''
};

const defaultCustomer = {
  employment_business_id: '',
  employment_status_id: '',
  marital_status_id: '',
  occupation_id: '',
  title: ''
};
